export default __webpack_public_path__ + "static/blogBG4-319b48b3c3a59e4c5e1bfa81f0026517.svg";